import React from 'react';
import { Box } from '../../../../../Box';
import { dataTableClassnames } from '../../../const/classNames';
import { IconButton } from '../../../../../IconButton/IconButton';
import { styled } from '../../../../../../styles';

interface SelectRowCellProps {
  dataTest?: string;
  className?: string;
  onToggle(value?: boolean): void;
  checked: boolean | undefined;
}

export const ExpandRowCell: React.FC<SelectRowCellProps> = ({ className, dataTest, checked, onToggle }) => {
  return (
    <Box dataTest={dataTest} className={`${dataTableClassnames.table.cell.selectRow} ${className || ''}`}>
      <StyledIconButton
        iconName="keyboard_arrow_down"
        dataTest="expanded-cell"
        $checked={!!checked}
        onClick={() => onToggle(!checked)}
      />
    </Box>
  );
};

const StyledIconButton = styled(IconButton)<{ $checked: boolean }>`
    [data-icon-name] {
        transition: all 0.2s ease-in-out;
        transform: ${({ $checked }) => ($checked ? 'rotate(180deg)' : 'rotate(0deg)')};
    }
`;
